import React from "react";

function EuroIcon ({className}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" className={className}>
      <path
        fill="inherit"
        d="M5 5a5 5 0 017.536-.536l2.12-2.12A8 8 0 001.583 5H0v2h1.062a8.047 8.047 0 000 2H0v2h1.582a8 8 0 0013.075 2.657l-2.121-2.121A5 5 0 014.999 11H9V9H4.1a5.027 5.027 0 010-2H9V5H5z"
      ></path>
    </svg>
  );
}

export default EuroIcon;